import HGLink from '../index'
import { LinkProps } from '../links.types'

export default function LinkTeams({
  children,
  query = '',
  ...props
}: LinkProps & { query?: string }) {
  return (
    <HGLink href={getTeamsHref(query)} aria-label='go to teams' {...props}>
      {children}
    </HGLink>
  )
}

export function LinkProfile({
  children,
  slug = '',
  ...props
}: LinkProps & { slug?: string }) {
  return (
    <HGLink href={getProfileHref(slug)} aria-label='go to profile' {...props}>
      {children}
    </HGLink>
  )
}

export function getTeamsHref(query?: string) {
  if (!query) {
    return '/teams'
  }
  return `/teams/${query}`
}

export function getProfileHref(slug: string) {
  return `/profile/${slug}`
}
